import { Label, Touchable } from "@grassrootly/rn-core";
import { TabTopBarProps } from "./Tab.types";

export default function TabTopBar({ isActive, tab, onPress }: TabTopBarProps) {
  return (
    <Touchable
      classNames={[
        "flex1",
        "alignItemsCenter",
        "justifyContentCenter",
        "pv16",
        "bwBottom-{1}",
        isActive ? "borderPrimary" : "borderSecondary",
        "mb-{8}",
      ]}
      key={tab.key}
      onPress={onPress}
    >
      <Label>{tab.title}</Label>
    </Touchable>
  );
}
